// src/services/news/queries/useGetNewsByTypeIdQuery.ts

import { useQuery } from '@tanstack/react-query'
import { apiGetAllNews } from '@/services/newsHome/api'
import { GetAllNewsResponse } from '@/services/newsHome/type'

type Options = {
    newsTypeId: number
    limit?: number
    enabled?: boolean
}

export const useGetNewsByTypeIdQuery = ({
    newsTypeId,
    limit = 10,
    enabled = true,
}: Options) => {
    const payload = {
        keywords: '',
        newsTypeId,
        isPublic: '',
        page: 1,
        pageSize: limit,
    }

    return useQuery({
        queryKey: ['news', 'by-type', newsTypeId, limit],
        queryFn: async () => {
            const res = await apiGetAllNews(payload)
            return res
        },
        select: (data: GetAllNewsResponse) => {
            return data?.isOK ? data.result.items : []
        },
        enabled: enabled && newsTypeId > 0,
        staleTime: 5 * 60 * 1000,
    })
}